import { render, staticRenderFns } from "./IntroModal.vue?vue&type=template&id=52dc9438"
import script from "./IntroModal.vue?vue&type=script&lang=js"
export * from "./IntroModal.vue?vue&type=script&lang=js"
import style0 from "./IntroModal.vue?vue&type=style&index=0&id=52dc9438&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports